import React from 'react'
import {useParams} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import axios, {AxiosError} from 'axios'
import {FormattedMessage, useIntl} from 'react-intl'
import {Spinner} from 'react-bootstrap'
export default function ActivateAcount() {
  const {token} = useParams()
  const [success, setSuccess] = React.useState<boolean>(false)
  const [error, setError] = React.useState('')
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const intl = useIntl()
  React.useEffect(() => {
    const checkActivation = async () => {
      try {
        setIsLoading(true)
        const API_URL = process.env.REACT_APP_API_URL
        await axios.post(`${API_URL}/api/auth/activate-account`, {token})
        setIsLoading(false)
        setError('')
        setSuccess(true)
      } catch (error) {
        const err = error as AxiosError
        const message: any = err.response?.data
        setError(message[intl.locale])
        setIsLoading(false)
        setSuccess(false)
      }
    }
    if (token) {
      checkActivation()
    }
  }, [token])
  return (
    <div className='alert alert-dismissible d-flex flex-center flex-column p-10'>
      {isLoading ? (
        <>
          <Spinner variant='primary' />
        </>
      ) : (
        <>
          {success === false ? (
            <span className='svg-icon svg-icon-5tx svg-icon-danger mb-5'>
              <KTSVG
                path='/media/icons/duotune/general/gen040.svg'
                className='svg-icon-md svg-icon-danger'
              />
            </span>
          ) : success === true ? (
            <span className='svg-icon svg-icon-5tx svg-icon-primary mb-5'>
              <KTSVG
                path='/media/icons/duotune/general/gen043.svg'
                className='svg-icon-md svg-icon-primary'
              />
            </span>
          ) : (
            <></>
          )}
          <div className='text-center'>
            <h5 className='fw-bolder fs-1 mb-5'>
              {success === true ? (
                <FormattedMessage id='REGISTRAION.SUCCESS' />
              ) : success === false ? (
                <FormattedMessage id='REGISTRAION.FAILED' />
              ) : (
                <></>
              )}
            </h5>

            <div className='separator separator-dashed border-danger opacity-25 mb-5'></div>

            <div className='mb-9'>
              {success === true ? (
                <FormattedMessage id='REGISTRAION.SUCCESS_DESC' />
              ) : success === false ? (
                error
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  )
}
